import React from "react";
import { PageBreakProps } from "../types";

export const PageBreak: React.FC<PageBreakProps> = () => {
  return React.createElement("RDPageBreak", {});
};
